       

            
function toggleAdvanced(){
    $("#advanced").toggle("slow");
}

function showMentions() {
    $('.showMentions').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let content = $(this).data('content');
        Fancybox.show([{src:"<div class='message' style='max-width:800px'>"+ content +"</div>", type: "html" }]);
    });
}

// Reglettes prix / puissance / km : leurs bornes suivent la selection (renvoyees
// par listannonces). Une reglette « non touchee » (aux bornes) n'est pas envoyee
// comme filtre, sinon elle figerait l'ancienne fourchette quand on elargit.
function bornesArrondies(bornes, pas, defaut)
{
    if (!bornes) {
        return defaut;
    }
    var min = Math.floor(parseInt(bornes[0] !== undefined ? bornes[0] : bornes.min) / pas) * pas;
    var max = Math.ceil(parseInt(bornes[1] !== undefined ? bornes[1] : bornes.max) / pas) * pas;
    if (isNaN(min) || isNaN(max)) {
        return defaut;
    }
    if (max <= min) {
        max = min + pas;
    }
    return [min, max];
}

function valeursDansBornes(valeurs, min, max)
{
    if (!valeurs) {
        return [min, max];
    }
    var bas = Math.max(min, Math.min(parseInt(valeurs[0]), max));
    var haut = Math.min(max, Math.max(parseInt(valeurs[1] !== undefined ? valeurs[1] : valeurs[0]), bas));
    return [bas, haut];
}

// Valeurs courantes d'une reglette, ou null si elle couvre toute sa fourchette.
function valeursTouchees(selecteur, min, max)
{
    if ($(selecteur).length == 0 || !$(selecteur).val()) {
        return null;
    }
    var v = $(selecteur).val().split(',').map(function (x) { return parseInt(x); });
    if (v.length < 2 || (v[0] <= min && v[1] >= max)) {
        return null;
    }
    return v;
}

function prixSlider(prixMin, prixMax)
{
    // Reglette absente quand la selection n'a qu'un seul prix (webauto.blade).
    if ($("#prix").length == 0) {
        return;
    }
    var prixValues = [parseInt(prixMin), parseInt(prixMax)];
    $("#prix").slider({
        tooltip: 'hide',
        id: "prixMinMax", 
        min: prixMinDefault, 
        max: prixMaxDefault, 
        step: 1000,
        range: true, 
        useCurrentValue: false,
        value: prixValues
    });

    $("#prixMin").text(new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(prixMin));
    $("#prixMax").text(new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(prixMax));

    $("#prix").on('slide', function(slideEvt) {
        $("#prixMin").text(new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(slideEvt.value[0]));
        $("#prixMax").text(new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(slideEvt.value[1]));

        $('#prix').val(slideEvt.value);
    });

    $('#prix').val(prixValues);
}
var prixDepart = valeursDansBornes(prixInit, prixMinDefault, prixMaxDefault);
prixSlider(prixDepart[0], prixDepart[1]);




function kmsSlider(kmsMin, kmsMax)
{
    if ($("#kms").length == 0) {
        return;
    }
    var kmsValues = [parseInt(kmsMin), parseInt(kmsMax)];
    $("#kms").slider({
        tooltip: 'hide',
        id: "kmsMinMax", 
        min: kmsMinDefault, 
        max: kmsMaxDefault, 
        step: 1000,
        range: true, 
        useCurrentValue: false,
        value: kmsValues
    });

    $("#kmsMin").text(new Intl.NumberFormat('fr-FR', { style: 'unit', unit: 'kilometer', maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(kmsMin));
    $("#kmsMax").text(new Intl.NumberFormat('fr-FR', { style: 'unit', unit: 'kilometer',maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(kmsMax));

    $("#kms").on('slide', function(slideEvt) {
        $("#kmsMin").text(new Intl.NumberFormat('fr-FR', { style: 'unit', unit: 'kilometer', maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(slideEvt.value[0]));
        $("#kmsMax").text(new Intl.NumberFormat('fr-FR', { style: 'unit', unit: 'kilometer', maximumFractionDigits: 0, minimumFractionDigits: 0, }).format(slideEvt.value[1]));

        $('#kms').val(slideEvt.value);
    });

    $('#kms').val(kmsValues);
}
var kmsDepart = valeursDansBornes(kmsInit, kmsMinDefault, kmsMaxDefault);
kmsSlider(kmsDepart[0], kmsDepart[1]);



function puissanceSlider(puissanceMin, puissanceMax)
{
    if ($("#puissance").length == 0) {
        return;
    }
    var puissanceValues = [parseInt(puissanceMin), parseInt(puissanceMax)];
    $("#puissance").slider({
        tooltip: 'hide',
        id: "puissanceMinMax", 
        min: puissanceMinDefault, 
        max: puissanceMaxDefault, 
        step: 5,
        range: true, 
        useCurrentValue: false,
        value: puissanceValues
    });

    $("#puissanceMin").text(parseInt(puissanceMin) + "cv");
    $("#puissanceMax").text(parseInt(puissanceMax) + "cv");

    $("#puissance").on('slide', function(slideEvt) {

        $("#puissanceMin").text(slideEvt.value[0] + "cv");
        $("#puissanceMax").text(slideEvt.value[1] + "cv");

        $('#puissance').val(slideEvt.value);
    });

    $('#puissance').val(puissanceValues);
}
var puissanceDepart = valeursDansBornes(puissanceInit, puissanceMinDefault, puissanceMaxDefault);
puissanceSlider(puissanceDepart[0], puissanceDepart[1]);

function bindAddFav() {
    
    $('.add_favorite').click(function() {
        Fancybox.show([{src: '<div class="fancybox-loading"></div>', type: "html", closeButton: "false" }],{
        on: {
            reveal: (fancybox) => {
                $('.fancybox-loading').removeClass('fancybox__content');
            },
        }
    });
        var self = this;
        var currentIcon = $(self).find('.icon-heart');
        $(currentIcon).removeClass('icon-heart').addClass('icon-heart-full');

        var carId = $(this).data('carid');
        var carName = $(this).data('carname');
        $.ajax({
            url: '/webauto/addtofavorite',
            data: {
                'carId': carId,
                'carName': carName
            },
            type: 'POST',
            success: function(response) {
                Fancybox.close();
                Fancybox.show([{src:'<div class="message"><h2>Favoris</h2><p>'+ response.msg +'</p></div>', type: "html", closeButton: "false" }]);
                setTimeout(function(){ 
                    Fancybox.close();
                } ,2000);
                
                if (response.nbfav) {
                    $('.nbfav').length ? $('.nbfav').html(response.nbfav) : $('.nav-utilities-link .icon-heart').append('<span class="nbfav">'+response.nbfav+'</span>');
                    pushEcommerceItem('add_to_wishlist', gaItemFromElement(self));
                }
            }
    });
    });
}
function gridlistoggle(){
    listButton = $('button.list-view');
    gridButton = $('button.grid-view');
    wrapper = $('.autoitems');
    flashlist = $('.flashlist');

    listButton.on('click',function(){
        gridButton.removeClass('on');
        listButton.addClass('on');
        // wrapper.removeClass('grid').addClass('list');
        wrapper.each(function( i, val ) {
            if($(val).hasClass('grid')){
                $(val).removeClass('grid').addClass('list');
            }
        });
        flashlist.show();
        document.cookie = 'display=list; path=/'; 
    });
    
    gridButton.on('click',function(){
        listButton.removeClass('on');
        gridButton.addClass('on');
        // wrapper.removeClass('list').addClass('grid');
        wrapper.each(function( i, val ) {
            if($(val).hasClass('list')){
                $(val).removeClass('list').addClass('grid');
            }
        });
        flashlist.hide();
        document.cookie = 'display=grid; path=/'; 
    });
}
gridlistoggle();
bindAddFav();
showMentions();

// function selectMulti(selectedColor) {
//     $('.carcolor').selectpicker('val', selectedColor);
// }
// selectMulti();


// function getDatasForm()
// {
//     prixMinMax = $('#prix').data('value').split(',');
//     var prix = '&prix=' + $('#prix').val();
    
//     var kms = '';
//     var kmsMinMax = [0, 100000]
//     // if ($('input[name="type"]:checked').val() != 'vo' && $('#kms').val() != undefined) {
//     if ($('#kms').val() != undefined) {
//         kmsMinMax = $('#kms').data('value').split(',');
//         var kms = '&kms=' + $('#kms').val();
//     }

//     puissanceMinMax = $('#puissance').data('value').split(',');
//     var puissance = '&puissance=' + $('#puissance').val();

//     var options = $('.carcolor option:selected');;

//     var selectedFamilles = $('.familles:checked').map( function () {
//         return $(this).val();
//     }).get().join('|');
//     var familles = '&famille=' + selectedFamilles;

//     var selectedEnergies = $('.energies:checked').map( function () {
//         return $(this).val();
//     }).get().join('|');
//     var energies = '&energie=' + selectedEnergies;

//     var selectedCouleurs = $('.couleurs:checked').map( function () {
//         return $(this).val();
//     }).get().join(',');
//     var couleurs = '&couleur=' + selectedCouleurs;

//     var selectedBoites = $('.boites:checked').map( function () {
//         return $(this).val();
//     }).get().join('|');
//     var boites = '&boite=' + selectedBoites;

//     var selectedEquipements = $('.equipements:checked').map( function () {
//         return $(this).val();
//     }).get().join('|');
//     var equipements = '&equipement=' + selectedEquipements;
    
//     var selectedFlags = $('.flags:checked').map( function () {
//         return $(this).val();
//     }).get().join('|');
//     var flags = '&flag=' + selectedFlags;
    
//     var selectedDispos = $('.dispos:checked').map( function () {
//         return $(this).val();
//     }).get().join('|');
//     var dispos = '&dispo=' + selectedDispos;

//     var datas = $("#form-garage :not(input[name=_token])").not('.checkbox').not('.carcolor').serialize() + prix + puissance + kms + familles + energies + couleurs + boites + equipements + flags + dispos;
//     return datas;
// }

// function isElementVisible(el) {
//     if(!el) return
//     const rect = el.getBoundingClientRect();
//     return (
//         rect.top >= 0 &&
//         rect.left >= 0 &&
//         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
//     );
// }

// const checkElement = document.getElementById('footerAnnonces');
// function checkElementVisibility() {
//     newValue = window.pageYOffset;
//     if (isElementVisible(checkElement) && oldValue - newValue < 0 && totalVehicules > limitNbCars) {
//         if (page < maxPage && !loading) {
//             page++;
//             loading = true;
//             infinitScroll(page);
//             checkElement.remove();
//         }
//     }
//     oldValue = newValue;
// }

// function checkPageShow(event) {
//     const nav = performance.getEntriesByType("navigation")[0];

//     const isBFCache = event.persisted || (nav && nav.type === "back_forward");

//     if (!isBFCache) {
//         return;
//     }
//     const savedHTML = sessionStorage.getItem('listAnnonces_html');
//     const savedScroll = sessionStorage.getItem('listAnnonces_scroll');

//     if (savedHTML) {
//         list.innerHTML = savedHTML;

//         // Restaurer la position de scroll quand le DOM est prêt
//         setTimeout(() => {
//             window.scrollTo(0, parseInt(savedScroll || 0));
//         }, 100);
//     }
//     page = sessionStorage.getItem('currentPage') || 1;
// }

// Attach the scroll event listener to the window or container
// window.addEventListener('scroll', checkElementVisibility);
// window.addEventListener('pageshow', checkPageShow);

// function infinitScroll(page = 1)
// {
//     $('.ajax-load').show();

//     let datas = getDatasForm();
//     datas+= '&page=' + page;
//     $.ajax({
//         url: '/webauto/listannonces',
//         data: datas,
//         headers: {
//             'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content,
//         },
//         type: 'POST',
//         success: function(results) {
//             $('#listAnnonces').append(results.list);
//             bindAddFav();
//             showMentions();
//             gridlistoggle();
//             $('[data-toggle="tooltip"]').tooltip()
//             loading = false;
//             $('.ajax-load').hide();
//             saveState();
//         }
//     });
// }

// function saveState() {
//     const currentPage = page;

//     sessionStorage.setItem('listAnnonces_html', list.innerHTML);
//     sessionStorage.setItem('listAnnonces_scroll', window.scrollY);
//     sessionStorage.setItem('currentPage', currentPage);

//     $('.webauto__fiche.fiche_auto').on("click", function(e) {
//         saveState();
//     });
// }

// function resetState() {
//     sessionStorage.removeItem('listAnnonces_html');
//     sessionStorage.removeItem('listAnnonces_scroll');
//     sessionStorage.removeItem('currentPage');
// }

function paginateLink()
{
    $('.page-link').on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        Fancybox.show([{src: '<div class="fancybox-loading"></div>', type: "html", closeButton: "false" }],{
        on: {
            reveal: (fancybox) => {
                $('.fancybox-loading').removeClass('fancybox__content');
            },
        }
        });
        window.history.replaceState(null, null, $(this).attr('href'));
        var href = $(this).attr('href').slice(1);

        $.ajax({
            url: '/webauto/listannonces',
            data: href,
            headers: {
                'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content,
            },
            type: 'POST',
            success: function(results) {
                Fancybox.close();
                $('#listAnnonces').html(results.list);
                paginateLink();
                bindAddFav();
                showMentions();
                pushViewItemList();
                $('html,body').animate({scrollTop: 450}, 'slow');
            }
        });
    });
}
paginateLink();
// document.addEventListener('DOMContentLoaded', function() {
//     $('#resetFilters').on("click", function(e){
//         resetState();
//     });
// });

// $('#webauto__smallengine__form').on("submit", function(e){
//     resetState();
// });

$('#form-garage').off("change").on("change slideStop", function(e) {
    if( e.target.id == 'prixMinMax' || e.target.id == 'puissanceMinMax' || e.target.id == 'kmsMinMax' || ((e.target.id == 'prix' || e.target.id == 'puissance' || e.target.id == 'kms') && e.type == "change")){
        return;
    } 
    
    Fancybox.show([{src: '<div class="fancybox-loading"></div>', type: "html", closeButton: "false" }],{
        on: {
            reveal: (fancybox) => {
                $('.fancybox-loading').removeClass('fancybox__content');
            },
        }
    });

    // Seules les reglettes resserrees par le visiteur partent en filtre.
    var kmsTouche = valeursTouchees('#kms', kmsMinDefault, kmsMaxDefault);
    var prixTouche = valeursTouchees('#prix', prixMinDefault, prixMaxDefault);
    var puissanceTouchee = valeursTouchees('#puissance', puissanceMinDefault, puissanceMaxDefault);

    var kms = kmsTouche ? '&kms=' + kmsTouche.join(',') : '';
    var prix = prixTouche ? '&prix=' + prixTouche.join(',') : '';
    var puissance = puissanceTouchee ? '&puissance=' + puissanceTouchee.join(',') : '';

    var options = $('.carcolor option:selected');

    var selectedFamilles = $('.familles:checked').map( function () {
        return $(this).val();
    }).get().join('|');
    var familles = '&famille=' + selectedFamilles;

    var selectedEnergies = $('.energies:checked').map( function () {
        return $(this).val();
    }).get().join('|');
    var energies = '&energie=' + selectedEnergies;

    var selectedCouleurs = $('.couleurs:checked').map( function () {
        return $(this).val();
    }).get().join(',');
    var couleurs = '&couleur=' + selectedCouleurs;

    var selectedBoites = $('.boites:checked').map( function () {
        return $(this).val();
    }).get().join('|');
    var boites = '&boite=' + selectedBoites;

    var selectedEquipements = $('.equipements:checked').map( function () {
        return $(this).val();
    }).get().join('|');
    var equipements = '&equipement=' + selectedEquipements;

    var selectedFlags = $('.flags:checked').map( function () {
        return $(this).val();
    }).get().join('|');
    var flags = '&flag=' + selectedFlags;
    
    var selectedDispos = $('.dispos:checked').map( function () {
        return $(this).val();
    }).get().join('|');
    var dispos = '&dispo=' + selectedDispos;

    var datas = $("#form-garage :not(input[name=_token])").not('.checkbox').not('.carcolor').serialize() + prix + puissance + kms + familles + energies + couleurs + boites + equipements + flags + dispos;
    $.ajax({
        url: '/webauto/listannonces',
        data: datas,
        headers: {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content,
        },
        type: 'POST',
        success: function(results) {
            window.history.replaceState(null, null, "/nos-vehicules/?"+datas);

            Fancybox.close();
            $('#listAnnonces').html(results.list);
            $('#form-garage').html(results.menu);
            $('#totalVehicules').html(results.total);
            totalVehicules = results.total;
            maxPage = results.maxPage;
            page = 1;
            getAlertDatas();
            gridlistoggle();
            paginateLink();
            showMentions();
            bindAddFav();
            toggleTri();
            pushViewSearchResults();
            pushViewItemList();
            // selectMulti(selectedColor);
            // Nouvelles bornes = selection courante ; une reglette touchee garde
            // sa fourchette (ramenee dans les bornes), sinon elle les epouse.
            var bornesPrix = bornesArrondies(results.prices, 1000, [prixMinDefault, prixMaxDefault]);
            prixMinDefault = bornesPrix[0];
            prixMaxDefault = bornesPrix[1];
            var vPrix = valeursDansBornes(prixTouche, prixMinDefault, prixMaxDefault);
            prixSlider(vPrix[0], vPrix[1]);

            var bornesPuissance = bornesArrondies(results.puissances, 5, [puissanceMinDefault, puissanceMaxDefault]);
            puissanceMinDefault = bornesPuissance[0];
            puissanceMaxDefault = bornesPuissance[1];
            var vPuissance = valeursDansBornes(puissanceTouchee, puissanceMinDefault, puissanceMaxDefault);
            puissanceSlider(vPuissance[0], vPuissance[1]);

            if ($('#kms').length > 0) {
                var bornesKms = bornesArrondies(results.kms, 1000, [kmsMinDefault, kmsMaxDefault]);
                kmsMinDefault = bornesKms[0];
                kmsMaxDefault = bornesKms[1];
                var vKms = valeursDansBornes(kmsTouche, kmsMinDefault, kmsMaxDefault);
                kmsSlider(vKms[0], vKms[1]);
            }
            $('[data-toggle="tooltip"]').tooltip();
            if(results.headlisting)
            {
                $('.headlisting').text(results.headlisting);
            }
            // $('.h2desc').text('').removeClass('descMarqueModeleTitre');
            // $('.descMarqueModele').text('');
            $('.descMarqueModele').text('');
            if(results.descMarqueModele)
            {
                // $('.h2desc').text(results.descMarqueModele.titre).addClass('descMarqueModeleTitre');
                // $('.descMarqueModele').html(results.descMarqueModele.desc);
                $('.descMarqueModele').html(results.descMarqueModele);
            }
            // saveState();
        }
    });
    
});

$('.alertBtn').click(function() {
    Fancybox.show([{src:'#alert_form', type: "html" }]);
});

function getAlertDatas()
{
    $('.alertBtn').hide();
    let nbParams = 0;
    $("#alertParameters").html('');
    $('select.form-select :selected').each(function() {
        if (this.value) {
            nbParams++;
            if(this.parentElement.name == 'marque' || this.parentElement.name == 'modeles') {
                $("ul#alertParameters").append("<li class='badge badge-secondary mx-1 defineAlertParams' data-type='" + this.parentElement.name + "' data-val='" + this.value + "'>" + this.text + "</li>"); 
            } else {
                $("ul#alertParameters").append("<li class='badge badge-secondary mx-1 defineAlertParams' data-type='" + this.parentElement.name + "' data-val='" + this.value + "'>" + this.text + " <a class='options_delete'><span class='icon-minus-circle'></span></a></li>"); 
            }
        }
    });
    if (nbParams >= 2) {
        $('.alertBtn').show();
    }

};

function sendAlert()
{
    let alertParams = {};
    $(".defineAlertParams").each(function() {
        alertParams[$(this).data('type')] = $(this).data('val');
    });
    alertParams['email'] = $('#emailarrivage').val()

    if(Object.keys(alertParams).length < 2) {
        Fancybox.close();
        getAlertDatas();
        Fancybox.show([{src:'<div class="message"><h2>Une erreur est survenue</h2><p>Veuillez définir au minimum 2 critères pour définir votre alerte !</p></div>', type: "html" }]);
        return;
    }

    fetch('/webauto/sendAlert', {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content
        },
        body: JSON.stringify(alertParams)
    })
    .then(r => r.text())
    .then(json => {
        Fancybox.close();
        
        Fancybox.show([{src:'<div class="message"><h2>Devis immédiat</h2><p>Votre demande a bien été enregistrée !</p></div>', type: "html" }]);
        setTimeout(function(){ 
            Fancybox.close();
        } , 3000);
        
    })
}

$("ul").on("click","span",function(event)
{
    $(this).parent().parent().fadeOut(500,function(){
        $(this).remove();
    });
    event.stopPropagation();
});


// dataLayer GA4 : view_search_results quand une marque est recherchee
// (une seule fois par couple marque / modele)
var lastSearchResults = null;
function pushViewSearchResults() {
    var brand = $.trim($('#form-garage input.marques:checked').parent().text());
    if (!brand) {
        return;
    }
    var model = $.trim($('#form-garage input.modeles:checked').filter(function() {
        return this.value !== '';
    }).parent().text());
    var key = brand + '|' + model;
    if (key === lastSearchResults) {
        return;
    }
    lastSearchResults = key;
    var data = { event: 'view_search_results', brand: brand };
    if (model) {
        data.model = model;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}
pushViewSearchResults();

// dataLayer GA4 : view_item_list avec les 10 premiers vehicules affiches
function pushViewItemList() {
    var items = [];
    $('#listAnnonces .webauto__fiche[data-ga-item]').slice(0, 10).each(function(index) {
        var item = gaItemFromElement(this);
        if (item) {
            item.currency = 'EUR';
            item.index = index;
            items.push(item);
        }
    });
    if (!items.length) {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
            item_list_name: 'Résultats de recherche',
            items: items
        }
    });
}
pushViewItemList();

function toggleTri(){
    $('#tri_sticky_select').on("change", function(e) {
        $('#tri select').val($('#tri_sticky_select :selected').val()).change();
    });
    $('#tri select').on("change", function(e) {
        $('#tri_sticky_select').val($(this).val());
    });
}
toggleTri();


window.resetModeles = function ()
{
    $('input[name="modeles"]').prop('checked', false);
}
